import React from "react";
import Chart from "react-apexcharts";
import { Card, CardBody } from "reactstrap";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const RevenueTrendChart = ({ data = [] }) => {
  const chartOptions = {
    chart: {
      height: 350,
      type: "area",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },

    dataLabels: {
      enabled: false,
    },

    stroke: {
      curve: "smooth",
      width: 3,
    },

    fill: {
      type: "solid",
      opacity: 0.12,
    },

    colors: ["#1cc88a"],

    grid: {
      borderColor: "#f1f1f1",
      strokeDashArray: 4,
    },

    markers: {
      size: 4,
      strokeWidth: 2,
      hover: {
        size: 6,
      },
    },

    xaxis: {
      categories: data.map(item =>
        dayjs(item.date, "D/M/YYYY").format("DD MMM")
      ),

      labels: {
        style: {
          fontSize: "12px",
        },
      },

      axisBorder: {
        show: false,
      },

      axisTicks: {
        show: false,
      },
    },

    yaxis: {
      min: 0,
      labels: {
        formatter: value => `₹${Number(value).toLocaleString()}`,

        style: {
          fontSize: "12px",
        },
      },
    },

    tooltip: {
      y: {
        formatter: value =>
          `₹${Number(value).toLocaleString()}`,
      },
    },
    legend: {
      position: "bottom",

      fontWeight: 500,

      labels: {
        useSeriesColors: true,
      },
    },
  };

  const series = [
    {
      name: "Revenue",
      data: data.map(item => Number(item.amount || 0)),
    },
  ];

  return (
    <Card className="card-height-100 border-0 shadow-sm">
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div>
            <h4 className="card-title mb-1">
              Revenue Trend
            </h4>
            <p className="text-muted mb-0">
              Daily Revenue Overview
            </p>
          </div>
        </div>
        <Chart
          options={chartOptions}
          series={series}
          type="area"
          height={320}
        />
      </CardBody>
    </Card>
  );
};

export default RevenueTrendChart;